var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 3.04297C11.0781 2.67188 11.0781 2.06641 10.707 1.71484L9.53516 0.542969C9.18359 0.171875 8.57812 0.171875 8.20703 0.542969L7.30859 1.44141C7.23047 1.51953 7.23047 1.67578 7.30859 1.77344L9.47656 3.94141C9.57422 4.01953 9.73047 4.01953 9.80859 3.94141L10.707 3.04297ZM6.54688 2.20312L1.41016 7.33984L1 9.70312C0.941406 10.0352 1.21484 10.3086 1.54688 10.25L3.91016 9.83984L9.04688 4.70312C9.14453 4.625 9.14453 4.46875 9.04688 4.37109L6.87891 2.20312C6.78125 2.125 6.625 2.125 6.54688 2.20312ZM2.71875 8.53125H3.65625V9.25391L2.38672 9.46875L1.78125 8.86328L1.99609 7.59375H2.71875V8.53125Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen3);
export default __webpack_public_path__ + "static/media/pen-3.1cc5f1d8.svg";
export { ForwardRef as ReactComponent };